import React, { useState, useEffect } from "react";
import NavBarEN from "./NavBarEN";
import NavBarMobileEN from "./NavBarMobileEN";
import { useMediaQuery } from "@uidotdev/usehooks";
import FormEN from "./FormEN";
import FooterEN from "./FooterEN";

import imageGradUvod from "../catalog/formiranje-grada1.jpg";
import imageGradUvod2 from "../catalog/formiranje-grada2.jpg";
import imageGradUvod3 from "../catalog/formiranje-grada3.jpg";
import imageGradUvod4 from "../catalog/formiranje-grada4.jpg";

import gradMetodologija1 from "../catalog/grad-metodologija1.png";
import gradMetodologija2 from "../catalog/grad-metodologija2.png";
import gradMetodologija4 from "../catalog/grad-metodologija4.jpg";

import gradTrendovi1 from "../catalog/grad-trend1.jpg";
import gradTrendovi2 from "../catalog/grad-trend2.jpg";
import gradTrendovi3 from "../catalog/grad-trendovi-3grafikona.png";

import gradKlimatologija from "../catalog/grad-klimatologija.gif";

import gradStete1 from "../catalog/grad-stete-1.png";
import gradStete2 from "../catalog/grad-stete-2.png";
import gradStete3 from "../catalog/grad-stete-3.png";
import gradStete4 from "../catalog/grad-stete-4.png";

import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import ReactHtmlParser from "html-react-parser";

const FlexibleContent = ({ items }) => {
  return (
    <div className="space-y-6">
      {items.map((item, index) => {
        if (item.type === "images-side-by-side") {
          return (
            <div key={index}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {item.images.map((img, i) => (
                  <div key={i}>{ReactHtmlParser(img)}</div>
                ))}
              </div>
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }
        if (item.type === "images-side-by-side-desc") {
          return (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {item.images.map((el, i) => (
                <div key={i} className="flex flex-col">
                  {el.img && ReactHtmlParser(el.img)}

                  {el.desc && (
                    <p className="mt-2 text-sm text-gray-700">{el.desc}</p>
                  )}
                </div>
              ))}
            </div>
          );
        }

        if (item.type === "image-full") {
          return (
            <div key={index}>
              <div className="w-full">{ReactHtmlParser(item.image)}</div>
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }

        if (item.type === "text") {
          return (
            <div key={index} className="my-4">
              {ReactHtmlParser(item.content)}
            </div>
          );
        }

        if (item.type === "table") {
          return (
            <div key={index} className="overflow-x-auto my-4">
              {ReactHtmlParser(item.content)}
              {item.desc && (
                <div className="mt-4 text-sm text-gray-700">
                  {ReactHtmlParser(item.desc)}
                </div>
              )}
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

export default function GradEN() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const isTabletOrLarger = useMediaQuery("only screen and (min-width: 769px)");
  const [activeTab, setActiveTab] = useState("formiranje-grada");

  const GRAD_DATA = {
    5: [
      { date: "28. 05. 2007.", file: "07052812.jpg" },
      { date: "9. 6. 2007.", file: "07060912.jpg" },
      { date: "23. 6. 2007.", file: "07062300.jpg" },
      { date: "20. 8. 2007.", file: "07082000.jpg" },
      { date: "11. 6. 2008.", file: "08061112.jpg" },
      { date: "10. 6. 2009.", file: "09061012.jpg" },
      { date: "28. 6. 2009.", file: "09062900.jpg" },
      { date: "12. 5. 2010.", file: "10051212.jpg" },
      { date: "14. 6. 2010.", file: "10061412.jpg" },
      { date: "16. 6. 2010.", file: "10061612.jpg" },
      { date: "19. 6. 2010.", file: "10061900.jpg" },
      { date: "18. 7. 2010.", file: "10071812.jpg" },
      { date: "31. 7. 2010.", file: "10073112.jpg" },
      { date: "8. 6. 2011.", file: "11060812.jpg" },
      { date: "10. 6. 2012.", file: "12061012.jpg" },
      { date: "22. 6. 2012.", file: "12062212.jpg" },
      { date: "11. 5. 2013.", file: "13051112.jpg" },
      { date: "17. 5. 2013.", file: "13051712.jpg" },
      { date: "30. 5. 2013.", file: "13053012.jpg" },
      { date: "10. 6. 2013.", file: "13061012.jpg" },
      { date: "22. 6. 2013.", file: "13062212.jpg" },
      { date: "17. 6. 2014.", file: "14061712.jpg" },
      { date: "27. 7. 2014.", file: "14072712.jpg" },
      { date: "24. 5. 2016.", file: "16052412.jpg" },
      { date: "19. 6. 2016.", file: "16061912.jpg" },
      { date: "20. 6. 2016.", file: "16062012.jpg" },
      { date: "23. 5. 2017.", file: "17052312.jpg" },
      { date: "3. 6. 2018.", file: "18060312.jpg" },
      { date: "22. 7. 2018.", file: "18072212.jpg" },
      { date: "19. 5. 2019.", file: "19051912.jpg" },
      { date: "28. 5. 2019.", file: "19052812.jpg" },
      { date: "7. 7. 2019.", file: "19070712.jpg" },
    ],

    6: [
      { date: "4. 8. 2006.", file: "06080412.jpg" },
      { date: "22. 5. 2007.", file: "07052212.jpg" },
      { date: "19. 6. 2007.", file: "07062000.jpg" },
      { date: "10. 8. 2007.", file: "07081012.jpg" },
      { date: "5. 6. 2009.", file: "09060512.jpg" },
      { date: "8. 7. 2009.", file: "09070812.jpg" },
      { date: "18. 6. 2010.", file: "10061812.jpg" },
      { date: "6. 8. 2009.", file: "10080612.jpg" },
      { date: "24. 6. 2011.", file: "11062400.jpg" },
      { date: "20. 7. 2011.", file: "11072012.jpg" },
      { date: "23. 6. 2013.", file: "13062300.jpg" },
      { date: "28. 8. 2013.", file: "13082812.jpg" },
      { date: "24. 6. 2014.", file: "14062412.jpg" },
      { date: "25. 6. 2014.", file: "14062512.jpg" },
      { date: "23. 8. 2014.", file: "14082312.jpg" },
      { date: "23. 6. 2019.", file: "19062312.jpg" },
    ],

    7: [
      { date: "13. 6. 2018.", file: "18061312.jpg" },
      { date: "15. 8. 2020.", file: "20081512.jpg" },
    ],
  };
  {
    /* 
  const GRAD_ZIP_DATA = {
    5: "/grad-data/extremes-grad-emagram-code5.zip",
    6: "/grad-data/extremes-grad-emagram-code6.zip",
    7: "/grad-data/extremes-grad-emagram-code7.zip",
  };
*/
  }
  const [hailCode, setHailCode] = useState("5");
  const [hailDate, setHailDate] = useState(GRAD_DATA["5"][0].file);

  useEffect(() => {
    if (GRAD_DATA[hailCode]?.length) {
      setHailDate(GRAD_DATA[hailCode][0].file);
    }
  }, [hailCode]);

  const data = [
    {
      label: "HAIL FORMATION",
      value: "formiranje-grada",
      desc:
        `<h2>Hail formation</h2>
      <p style="margin-bottom: 10px; color: #000;">
Hail is precipitation consisting of ice in the form of balls or irregular lumps. It can be transparent, partially opaque, or completely opaque. Hailstones are usually spheroidal, conical, or irregular in shape, with diameters ranging from 5 to 50 mm. Ice grains with diameters of less than 5 mm are, by convention, called small hail. Hail is the main meteorological hazard in Europe, where individual hailstorms cause losses of one billion euros. In recent years, it has caused record losses exceeding five billion euros in France in 2022 and Italy in 2023 (Cusack and Cox, 2024). It is a devastating meteorological phenomenon for critical infrastructure, buildings, motor vehicles, and especially crops. Our people used to say that the harvest was killed by ice: in 15 to 20 minutes, hail can destroy the entire grape and fruit harvest and devastate grain fields.      </p>` +
        `<p style="margin-bottom: 10px; color: #000;">
Hail always forms in convective clouds, almost always in cumulonimbus. Strong updrafts in these clouds lift air to higher altitudes, causing the condensation of water vapour. This results in the formation of many supercooled cloud droplets. In this environment, the hail embryo – whether a frozen raindrop or graupel – collides with supercooled droplets that freeze onto it, forming hail. The longer a hailstone remains in the cloud, carried by the updraft, the more supercooled droplets it collects, allowing it to grow larger. Hail forms at altitudes where the air temperature is between -10°C and -30°C. The greater the vertical velocity in the cumulonimbus, the larger the hailstones that the updraft can support.
       </p>` +
        `<p style="margin-bottom: 16px; color: #000;">
As hail grows and becomes heavier, its falling speed eventually exceeds the speed of the updraft in the cumulonimbus cloud. At this point, it begins to fall towards the ground and continues to grow by collecting supercooled cloud droplets and raindrops along its path. A strong updraft can catch the hailstone again, carrying it upwards and accelerating its growth. This process, known as recirculation, is the key mechanism for the formation of large hailstones. When a hailstone enters an area where temperatures are above 0°C, it begins to melt. Small hailstones generally melt and become large raindrops before reaching the ground. Large hailstones, with a diameter greater than 5 mm, reach the ground still frozen and are recorded as hail. Figure 1 shows the emagrams observed on 23 June 2024 at 00 UTC in Belgrade and at 12 UTC in Niš, together with hodographs and calculated stability parameters. Figure 2 shows the hailstones that formed in that supercell and fell on the ground.
      </p>` +
        `<p style="color: #000; font-size: 14px;">
Cusack, S., Cox, T., 2024. Brief communication: Investigating trends in European hailstorm damage using CMIP6-DAMIP climate models.
 <a
  href="http://dx.doi.org/10.5194/nhess-2024-210"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  http://dx.doi.org/10.5194/nhess-2024-210
</a>

, <br>Natural Hazards Earth System Sciences Discussions [preprint]. URL: <a
  href="https://nhess.copernicus.org/preprints/nhess-2024-210"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  https://nhess.copernicus.org/preprints/nhess-2024-210
</a>.
        </p>`,
      content: [
        {
          type: "images-side-by-side",
          images: [
            `<img src="${imageGradUvod}" alt="Grad Uvod">`,
            `<img src="${imageGradUvod2}" alt="Emagrami">`,
          ],
          desc: `<p>Figure 1 Emagrams with hodograph and calculated stability parameters for 23 June 2024 at 00 UTC for Belgrade and at 12 UTC for Niš.</p>`,
        },

        {
          type: "images-side-by-side",
          images: [
            `<img src="${imageGradUvod3}" alt="Grad u Sjenici slika">`,
            `<img src="${imageGradUvod4}" alt="Grad u Sjenici">`,
          ],
          desc: `<p>Figure 2 Hail in Sjenica, 23 June 2024 (photo: Vladan Vučković)</p>`,
        },
      ],
    },
    {
      label: "METODOLOGY",
      value: "metodologija",
      desc:
        `<h2>Metodology</h2>
      <p style="margin-bottom: 10px; color: #000;">
In Serbia, hail occurs mainly during the warmer months, from April to September (in approximately 97% of cases). It is very rare during the rest of the year, as shown in Figure 1. Hail most frequently occurs in the afternoon, with about 70% of all cases recorded between 14:00 and 18:00, and 92.4% between 12:00 and 21:00 (Figure 2). To mitigate hail damage, clouds in Serbia are seeded from the ground using rockets filled with 400 grams of a pyrotechnic mixture containing about 8% silver iodide. The Republic Hydrometeorological Institute of Serbia carries out hail suppression with the primary aim of reducing the frequency of hail or decreasing the diameter of hailstones. The ultimate goal is to minimise potential damage to crops and property. For this purpose, a dense network of rocket launch stations (RLS) has been established, with stations located much closer together than synoptic and climatological stations. Trained personnel at these stations record phenomena produced by convective clouds: rain, thunder, strong wind, hail, and the size of hailstones. As hail is a small-scale phenomenon (affecting areas 20 to 25 km long and 200 m to 4 km wide), RLS data are the most reliable and best available for hail analysis, since hail can fall between two meteorological stations and thus go unrecorded. The predominant hail size is measured visually, with observers comparing the hailstones to familiar objects (such as a bean, walnut, or hazelnut). In the practice of the Republic Hydrometeorological Institute, seven classes of hail are used (codes 1–7, Table 1), as well as a category for very small hailstones, such as grains of ice smaller than a grain of corn (code 0), so-called small hail.
      </p>` +
        `<p style="margin-bottom: 10px; color: #000; font-size: 18px; font-style: italic;"> 
Distributions of hailstones by size
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
Between 2002 and 2015 in Serbia, in almost 80% of cases, hailstones were smaller than a hazelnut. Hailstones larger than a pigeon's egg rarely fell, accounting for only about 0.8% of occurrences during this period. The proportion of large hailstones, larger than a hen's egg, was negligible, occurring in just 0.01% of cases. A similar distribution of hailstone sizes was observed for the period 1981–2015 in Serbia excluding Vojvodina, although during that time the distribution was shifted towards larger hailstones. This raised the question of whether the shift towards smaller hailstones was due to the influence of orography, as Vojvodina is mostly flat. Therefore, an analysis of hailstone size distribution for the period 2002–2015 was conducted for Serbia without Vojvodina. The distribution was very similar to that for the entire area of Serbia. Based on this, it was concluded that in the recent period (2002–2015), there was a greater occurrence of smaller hailstones.
      </p>` +
        `<p style="margin-bottom: 10px; color: #000; font-size: 18px; font-style: italic;"> 
        Hail duration
</p>` +
        `<p style="margin-bottom: 16px; color: #000;">
In more than 55% of cases, hail fell for 1–2 minutes (Figure 3), and in 75% of cases for less than 5 minutes. A hail event of long duration is rarely recorded. In only 8% of cases did the hail last 10 minutes or more. The average duration of hail precipitation is about 3.5 minutes. There is a significant decreasing trend in the average seasonal duration of hail events, with a rate of -0.0312 min/year, with a significance level of α = 0.001.</p>` +
        `<p style="color: #000; font-size: 14px;">
Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15),6556-6572 (DOI:10.1002/joc.7212). 
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradMetodologija1}" alt="METODOLOGIJA Grad">`,
          desc: `Figure 1 Frequency of hail in Serbia during the period 2002–2015. The total number of occurrences of hail and small hail was 23,353, of which 97.4% were observed in the warm part of the year (mainly in May, June, and July), and only 0.4% in October.`,
        },
        {
          type: "image-full",
          image: `<img src="${gradMetodologija2}" alt="METODOLOGIJA Grad">`,
          desc: `Figure 2 Distribution of hail precipitation during a day.`,
        },

        {
          type: "table",
          content: `
          <table class="min-w-full border-collapse border border-gray-300">
  <thead>
    <tr class="bg-gray-100">
      <th class="border border-gray-300 px-2 py-1">Code</th>
      <th class="border border-gray-300 px-2 py-1">Hailstone diameter (mm)</th>
      <th class="border border-gray-300 px-2 py-1">Hailstone size</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="border border-gray-300 px-2 py-1">0</td>
      <td class="border border-gray-300 px-2 py-1">0,1 – 3,0</td>
      <td class="border border-gray-300 px-2 py-1">Small hail</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">1</td>
      <td class="border border-gray-300 px-2 py-1">4 – 8</td>
      <td class="border border-gray-300 px-2 py-1">Corn kernel</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">2</td>
      <td class="border border-gray-300 px-2 py-1">9 – 12</td>
      <td class="border border-gray-300 px-2 py-1">Bean</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">3</td>
      <td class="border border-gray-300 px-2 py-1">13 – 20</td>
      <td class="border border-gray-300 px-2 py-1">Hazelnut</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">4</td>
      <td class="border border-gray-300 px-2 py-1">21 – 30</td>
      <td class="border border-gray-300 px-2 py-1">Walnut</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">5</td>
      <td class="border border-gray-300 px-2 py-1">31 – 35</td>
      <td class="border border-gray-300 px-2 py-1">Pigeon egg</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">6</td>
      <td class="border border-gray-300 px-2 py-1">36 – 50</td>
      <td class="border border-gray-300 px-2 py-1">Chicken egg</td>
    </tr>
    <tr>
      <td class="border border-gray-300 px-2 py-1">7</td>
      <td class="border border-gray-300 px-2 py-1">&gt; 50</td>
      <td class="border border-gray-300 px-2 py-1">Greater than a chicken egg</td>
    </tr>
  </tbody>
</table>

        `,
          desc: `<p>Table 1 Hailstone diameter as classified by the Republic Hydrometeorological Institute.</p>`,
        },

        {
          type: "image-full",
          image: `<img src="${gradMetodologija4}" alt="METODOLOGIJA Grad">`,
          desc: `Figure 3 Relative frequency of the duration of hail and small hail.`,
        },
      ],
    },
    {
      label: "TRENDS",
      value: "trendovi",
      desc: `<h2>Trends</h2>
      <p style="margin-bottom: 10px; color: #000;">
Figure 1 shows the annual number of days with hail and small hail across the territory of Serbia, excluding Vojvodina, from 1981 to 2015. The highest number of hail days, 83, was recorded in 2002. Annual averages were calculated for two sub-periods, 1981–1998 and 2000–2015, with values of 48.5 and 56.9 days, respectively. Thus, in the last 16 years of the period, the average number of hail days was higher than in the first 17 years. Linear regression shows an increasing trend, but it is not statistically significant, as the coefficient of determination is very low (R² = 0.0629). Nevertheless, a positive monotonic trend of 0.308 days per year is likely at the 0.05 confidence level. Monthly trends were also examined, and only May showed a positive monotonic trend of 0.136 days per year (α = 0.05).
      </p>
      <p style="margin-bottom: 10px; color: #000;">
Figure 2 shows the total number of hail and small hail occurrences. Hail occurrence is highly variable. The lowest number of occurrences, 551, was recorded in 2015, when 1,364 RLS stations were active. The highest number of occurrences since 1957 was recorded in 2007, with 1,633 active RLS stations. No statistically significant linear trend was found for the number of hail and small hail occurrences. The Mann–Kendall test did not indicate a monotonic trend for all hail sizes or individual sizes. Interestingly, a positive monotonic trend of 6.25 occurrences per year exists for hailstones smaller than a grain of corn, with a significance level of 6.7%.
      </p>
      <p style="margin-bottom: 10px; color: #000;">
For the EXTREMES project, extreme hail days from 2005–2020 were analyzed. Extreme hail events are defined as those with diameters greater than 21 mm (codes 4, 5, 6, and 7). Such events accounted for 20.8% of all hail days during the period, as shown in Figure 3. According to linear regression, the number of days with 21–30 mm hail (code 4) increased slightly by 0.6 days over 16 years, but this trend is not statistically significant (p = 0.794). The slope for 31–35 mm hail (code 5) is zero, also not significant. Days with 36–50 mm hail decreased, but the trend is not significant. Only two days with hail over 50 mm (code 7) were recorded, so no trend could be determined. The Mann–Kendall test confirms no monotonic trends for extreme hail events. Thus, the number of extreme hail days did not increase during 2005–2020.
      </p>
      <ul style="margin-bottom: 16px; color: #000; padding-left: 20px; list-style: disc;">
      <li>Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15), 6556–6572 (DOI:10.1002/joc.7212).</li>
      <li>No trend at the 5% significance level for the occurrence of hail or small hail for any hailstone size.</li>
      <li>A positive monotonic trend of 6.25 occurrences/year for small hail (cobs) exists, with a risk of 6.71%.</li>
      <li>No trend in the frequency of hail and small hail occurrences.</li>
      <li>Hail and small hail events are becoming shorter in duration (decreasing trend of –0.0312 min/year).</li>
      <li>The first occurrence of hail and small hail does not appear earlier in the season.</li>
      <li>The number of extreme hail days has not increased.</li>
    </ul>
    <p style="color: #000; font-size: 14px;">
Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15), 6556–6572 (DOI:10.1002/joc.7212).
<br>
Vujović D, Vučković V, Zečević A, 2025. Analysis and Trends of the Stability Indices During Hail Days Derived from the Radiosonde Observations from Belgrade (Serbia). Atmosphere, 16(5), 520,
<a 
  href="https://doi.org/10.3390/atmos16050520"
  target="_blank"
  class="text-blue-700 hover:text-[#1D4ED8] hover:underline"
>
  https://doi.org/10.3390/atmos16050520
</a>
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradTrendovi1}" alt="Figure 1. Annual number of days with hail and small hail in Serbia (excluding Vojvodina), 1981–2015.">`,
        },
        {
          type: "text",
          content: `<p style="font-size: 14px;">Figure 1. Annual number of days with hail and small hail in Serbia (excluding Vojvodina), 1981–2015. Solid and dotted black lines represent the 5-year and 10-year moving averages, respectively.</p>`,
        },
        {
          type: "image-full",
          image: `<img src="${gradTrendovi2}" alt="Figure 2. Annual number of hail and small hail occurrences in Serbia, excluding Vojvodina, 1981–2015.">`,
        },
        {
          type: "text",
          content: `<p style="font-size: 14px;">Figure 2. Annual number of hail and small hail occurrences in Serbia, excluding Vojvodina, 1981–2015.</p>`,
        },
        {
          type: "image-full",
          image: `<img src="${gradTrendovi3}" alt="Figure 3. Number of days with extreme hail observed, 2005–2020.">`,
        },
        {
          type: "text",
          content: `<p style="padding-left: 2%; padding-right:2%; font-size: 14px;">Figure 3. Number of days with extreme hail (codes 4, 5, 6) in 2005–2020. Linear regression is shown. R², t, and p indicate the coefficient of determination, t-statistic, and p-value, respectively.</p>`,
        },
      ],
    },
    {
      label: "CLIMATOLOGY",
      value: "klimatologija",
      desc: `<h2>Hail climatology</h2>
<p style="margin-bottom: 10px; color: #000;">
Figure 1 shows the average annual number of days with hail and small hail precipitation for each rocket launch station (RLS). There were about 1,600 active RLS. This is the first climatological study of hail in Serbia of this kind. The average annual number of days with hail per RLS ranged from 0 to 2.9. At only one RLS (RLS Hetin, Žitište municipality), the hail was not monitored at all during the 10 years it was active. At as many as 70% of all RLS, the average annual number of days with hail was less than one. An average of two or more days with such precipitation was recorded at 23 RLS. The highest frequency of hail was observed in the south-western mountainous part of Serbia, with an average of 1.2 days per year per RLS (minimum 0.3, maximum 2.7 days). During the warmer part of the year, air temperature is higher, so the development of cumulonimbus clouds is more frequent and intense. In mountainous areas, there is an additional, forced upward flow of air, which increases the likelihood of strong convection developing, which can produce hail.
</p>
<p style="margin-bottom: 10px; color: #000;">
The frequency of hail decreases towards the east and north. In Vojvodina, the average annual number of days with hail and small hail per RLS is 0.7 days. On Fruška Gora, this number is slightly higher, amounting to 1.9 days per year per RLS. The area with an increased average annual number of days with hail extends along the mountains: in the southwest (Mount Cer, 689 m a.s.l., and Valjevske planine, 1,346 m a.s.l.), in Central Serbia (Mount Rudnik, 1,132 m a.s.l.), Western Serbia (Jelica, 929 m a.s.l.; Javor, 1,519 m a.s.l.; Golija, 1,833 m a.s.l.), and the southeast (Jastrebac, 1,492 m a.s.l.; Radan, 1,408 m a.s.l.). A second, less pronounced, branch of increased frequency in the average annual number of days with hail extends over the mountains of eastern Serbia.
</p>
<p style="margin-bottom: 10px; color: #000;">
The annual variability in hail and small hail precipitation is clearly evident. During individual years of the observed period, a maximum of 2 days with hail were recorded at 86 to 99% of active RLS stations. However, there were also years when this phenomenon was observed for more than 5 days at a single station. The maximum of 10 days with hail in one year was recorded in 1983 at RLS Izvor, Svrljig municipality, and in 1986 at RLS Amzići, municipality of Nova Varoš. Both stations are located in mountainous areas.
</p>
<p style="color: #000; font-size: 14px;">
Nađ J., D. Vujović, V. Vučković, 2021. Hail characteristics in Serbia based on data obtained from the network of hail suppression system stations. Int. J. Climatol., 41(15),6556-6572 (DOI:10.1002/joc.7212).
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradKlimatologija}" alt="Klimatologija Grada" style="max-width:100%;height:auto;">`,
          desc: `Figure 1 The average annual number of days with hail and small hail pre rocket launch station in Serbia during the period 1981–2005. Each point represents the location of one RLS.`,
        },
      ],
    },
    {
      label: "HAIL DAMAGE",
      value: "stete",
      desc: `<h2>Hail damage</h2>
<p style="margin-bottom: 10px; color: #000;">
The goal of cloud seeding is to reduce hail size, thereby minimising potential damage to crops and property. As it is not possible to completely prevent hail damage, data on damage is collected to evaluate the effectiveness of hail suppression systems. Primarily, crop damage from individual and municipal plots was analysed. The analysis was based on data obtained from municipal services and a committee of experts from the Republic Hydrometeorological Institute of Serbia.
</p>
<p style="margin-bottom: 10px; color: #000;">
Between 2002 and 2018, there were 597 days with hail damage to crops and 1,078 days with hail. On average, there were 33.2 days with hail damage per year, compared to 63.4 days with hail. The largest area damaged in a single day was 18,914.96 ha on 21 August 2004, when a strong storm struck Vojvodina. On average, 51,433 ha were damaged annually, regardless of the percentage of damage, representing 1.01% of the total agricultural area. The average annual area damaged, adjusted to 100% damage, was 22,414 ha, or 0.44% of the total agricultural area. Before the hail suppression system was introduced, this damage affected about 3% of the total agricultural area.
</p>
<p style="margin-bottom: 10px; color: #000;">
Figure 1 shows the annual number of days with hail (NHD) and days with hail damage to crops (NDD) in Serbia for the period 2002–2018. The monthly distribution of the number of hail occurrences (NHO) and the area of crops damaged by hail (HDA) for the same period is presented in Figure 2. Figure 3 displays the average annual number of days with hail damage to crops for each municipality, while Figure 4 shows the average annual area with hail damage to crops (expressed as a percentage) for each municipality.
</p>
<p style="color: #000; font-size: 14px;">
Nađ J, Kardum Đ, Vujović D, 2024. Damage to crops caused by hail in Serbia. 4th European Hail Workshop, Karlsruhe, Germany, March 5-7, 2024
</p>`,
      content: [
        {
          type: "image-full",
          image: `<img src="${gradStete1}" 
          alt="Figure 1 Annual number of hail days (NHD) and number of days with damage on crops (NDD) in Serbia between 2002 and 2018." 
          style="max-width:100%;height:auto;">`,
          desc: `Figure 1 Annual number of hail days (NHD) and number of days with damage on crops (NDD) in Serbia between 2002 and 2018.`,
        },
        {
          type: "image-full",
          image: `<img src="${gradStete2}" 
          alt="Figure 2 Monthly distribution of the number of hail occurrences (NHO) and the area of crops damaged by hail (HDA) during the period 2002–2018." 
          style="max-width:100%;height:auto;">`,
          desc: `Figure 2 Monthly distribution of the number of hail occurrences (NHO) and the area of crops damaged by hail (HDA) during the period 2002–2018.`,
        },
        {
          type: "images-side-by-side-desc",
          images: [
            {
              img: `<img src="${gradStete3}" alt="Slika 3">`,
              desc: "Figure 3 Average annual number of days with hail damage to crops in each municipality.",
            },
            {
              img: `<img src="${gradStete4}" alt="Slika 4">`,
              desc: "Figure 4 Average annual area with hail damage to crops (expressed as a percentage) for each municipality.",
            },
          ],
        },
      ],
    },

    {
      label: "DATA",
      value: "podaci",
      content: [
        <div className="suseDeo flex flex-col md:flex-row">
          {/* LEVI DEO */}
          <div className="suseDeoVeci w-full md:w-3/5 p-4">
            <div className="flex flex-col md:flex-row md:items-end md:gap-6">
              {/* IZBOR KODA */}
              <div className="flex flex-col">
                <label className="font-semibold mb-2">
                  Select hailstone size:
                </label>
                <select
                  value={hailCode}
                  onChange={(e) => setHailCode(e.target.value)}
                  className="border p-2 w-full md:w-56 rounded-xl"
                >
                  <option value="5">Code 5 (31–35 mm)</option>
                  <option value="6">Code 6 (36–50 mm)</option>
                  <option value="7">Code 7 (&gt; 50 mm)</option>
                </select>
              </div>

              {/* IZBOR DATUMA */}
              <div className="flex flex-col">
                <label className="font-semibold mb-2">Izaberi datum:</label>
                <select
                  value={hailDate}
                  onChange={(e) => setHailDate(e.target.value)}
                  className="border p-2 w-full md:w-56 rounded-xl"
                >
                  {GRAD_DATA[hailCode].map((item) => (
                    <option key={`${item.file}-${item.date}`} value={item.file}>
                      {item.date}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* SLIKA */}
            <div className="mt-4">
              <img
                src={`/grad/${hailDate}`}
                alt="Ekstreman grad"
                className="max-w-full mx-auto border"
              />
            </div>
            {/* DUGMAD ZA PREUZIMANJE iskljuceno 
            <div className="mt-6 flex flex-col md:flex-row justify-center gap-4">
              
              <a
                href={`/grad/${hailDate}`}
                download={hailDate}
                className="bg-blue-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi sliku
              </a>

             
              <a
                href={GRAD_ZIP_DATA[hailCode]}
                download
                className="bg-green-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi podatke
              </a>

              
              <a
                href="/grad-data/extremes-grad-emagram-svi-kodovi.zip"
                download
                className="bg-red-500 font-bold text-white px-3 py-2 rounded text-center"
              >
                Preuzmi sve podatke
              </a>
            </div>
            */}
          </div>

          {/* DESNI DEO */}
          <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
            <h4 className="font-semibold mb-2">HAIL</h4>
            <p className="text-black">
              The vertical profile of the atmosphere is shown by emagrams,
              hodographs, and calculated instability indices for days with
              extreme hailstorms in Serbia.
            </p>
            <p className="text-black">
              Surveys with calculated indices for the period 2020-2024 for
              Belgrade can be downloaded &nbsp;
              <a
                href="http://haos.ff.bg.ac.rs/.extremes/grad/emagram/bgd2.tar.gz"
                className="text-blue-700 hover:text-[#1D4ED8] hover:underline"
              >
                here
              </a>
              , and for Niš &nbsp;
              <a
                href="http://haos.ff.bg.ac.rs/.extremes/grad/emagram/nis2.tar.gz"
                className="text-blue-700 hover:text-[#1D4ED8] hover:underline"
              >
                here
              </a>
              .
            </p>
          </div>
        </div>,
      ],
    },
  ];

  return (
    <>
      {isTabletOrLarger && <NavBarEN />}
      {isSmallDevice && <NavBarMobileEN />}
      <div className="container mx-auto text-center min-h-screen md:mb-6 ">
        <Tabs value={activeTab} className="max-w-screen-xl mx-auto">
          <TabsHeader
            className="bg-transparent flex justify-center flex-wrap md:flex-nowrap mx-2 md:mx-0"
            indicatorProps={{
              className: "bg-gray-900/10 shadow-none !text-gray-900",
            }}
            onChange={(value) => setActiveTab(value)}
          >
            {data.map(({ label, value }) => (
              <Tab className="probaTaba2" key={value} value={value}>
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody>
            {data.map(({ value, tabs, desc }) => (
              <TabPanel key={value} value={value}>
                {value === "podaci" ? (
                  data.find((d) => d.value === "podaci")?.content
                ) : (
                  <>
                    {/* Prikaz za ostale glavne tabove kao što su Uvod, Metodologija itd. */}
                    <div className="suseDeo flex flex-col md:flex-row">
                      <div className="suseDeoVeci w-full md:w-3/5 p-4">
                        {/* Use the flexible content component */}
                        <FlexibleContent
                          items={
                            value === "podaci"
                              ? []
                              : data.find((d) => d.value === value)?.content ||
                                []
                          }
                        />
                      </div>
                      <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
                        {desc && ReactHtmlParser(desc)}
                      </div>
                    </div>
                  </>
                )}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <FormEN />
      <FooterEN />
    </>
  );
}
